import BaseService from "./BaseService";

export default class PINSettingService extends BaseService {
  controllerName = "establishment";

  async GetPinSetting(establishmentId: string): Promise<any> {
    const resp = await this.Get(`${establishmentId}/pinsetting`, {});
    return resp.data ? resp.data : resp;
  }

  async CreatePinSetting(establishmentId: string, data: any): Promise<any> {
    const params = {
      pinLength: data.pinLength,
      maxGenerationAttempt: data.maxGenerationAttempt,
      allowAutoPINGeneration: data.autoPinGeneration
    };
    const resp = await this.Post(`${establishmentId}/pinsetting`, params);
    return resp;
  }

  async UpdatePinSetting(establishmentId: string, settingId: string, data: any): Promise<any> {
    const params = {
      pinLength: data.pinLength,
      maxGenerationAttempt: data.maxGenerationAttempt,
      allowAutoPINGeneration: data.autoPinGeneration
    };
    const resp = await this.Put(`${establishmentId}/pinsetting/${settingId}`, params);
    return resp;
  }
}
